/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Sep-30
 *
 **/

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import account from './account.module'
import procedures from './procedures.module'
import processes from './processes.module'
import orders from './orders.module'
import alerts from './alert.module'
import cart from './cart.module'
import fiscalContact from "./fiscal_contact.module";

const store = new Vuex.Store({
    modules: {
        account,
        procedures,
        processes,
        alerts,
        orders,
        cart,
        fiscalContact
    }
})

export default store